module.exports = __webpack_public_path__ + "static/media/3x3 minus row.55ccdc67.kra";